import { Field } from "formik";
import { Input, Row, Col } from "antd";
import React, { Fragment } from "react";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";
export default ({
  disabled,
  highwayTo,
  highwayFrom,
  unregisteredProperty,
  rowData,
}) => {
  return (
    <Fragment>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="inspector"
            labelText="Inspector"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="eto_name"
            labelText="ETO Name"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col className="column-left" span={12}>
          <Field
            InputType={Input}
            component={FormInputField}
            name="property_number"
            labelText="Property No"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col className="column-right" span={12}>
          <Field
            InputType={Input}
            component={FormInputField}
            name={
              rowData?.locality !== null &&
              rowData?.locality !== undefined &&
              rowData.locality !== "" &&
              "locality"
            }
            labelText="Cluster Name"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
            value={
              (rowData?.locality !== null ||
                rowData?.locality !== undefined ||
                rowData.locality !== "") &&
              "-"
            }
            placeholder={"—"}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="highway_name"
            labelText="Highway Name"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="highway_kms"
            labelText="KMs"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        {highwayTo !== null && (
          <Col span={highwayFrom ? 12 : 24} className={`${highwayFrom ? "column-left" : ""}`}>
            <Field
              InputType={Input}
              component={FormInputField}
              name="highway_to"
              labelText="To"
              hideErrorMessage={true}
              className="text-field"
              disabled={disabled}
            />
          </Col>
        )}
        {highwayFrom !== null && (
          <Col
            span={highwayTo ? 12 : 24}
            className={`${highwayTo ? "column-right" : ""}`}
          >
            <Field
              InputType={Input}
              component={FormInputField}
              name="highway_from"
              labelText="From"
              hideErrorMessage={true}
              className="text-field"
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="circle"
            labelText="Circle"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="tehsil"
            labelText="Tehsil"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="mouza"
            labelText="Mouza"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="district"
            labelText="District"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12} className="column-left">
          <Field
            InputType={Input}
            component={FormInputField}
            name="property_type"
            labelText="Property Type"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
        <Col span={12} className="column-right">
          <Field
            InputType={Input}
            component={FormInputField}
            name="khasra_no"
            labelText="Khasra No"
            hideErrorMessage={true}
            className="text-field"
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        {rowData.status === "registered" && (
          <Col span={12} className="column-left">
            <Field
              InputType={Input}
              component={FormInputField}
              name="pin"
              labelText="Property PIN"
              hideErrorMessage={true}
              className="text-field"
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
    </Fragment>
  );
};
